import React, { useState, useEffect, useRef, useCallback } from 'react';
import {
    CarouselComponent,
    CarouselItemsDirective,
    CarouselItemDirective,
} from '@syncfusion/ej2-react-navigations';
import * as Inovx from '@shared';
import HomeFacilityStore from '../stores/HomeFacilityStore';
import HomeStore from '../stores/HomeStore';
import HomeFacilityActions from '../actions/HomeFacilityActions';
import type { IHomeFacility } from '../constants/interfaces';

const ListHelper = Inovx.Shared.Common.ListHelper;

// Default facility thumbnail (inline so no separate image request needed)
const facilityImg = `data:image/png;base64,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`;

interface Props {
    onError?: (err: any) => void;
}

function chunkArray<T>(arr: T[], size: number): T[][] {
    const result: T[][] = [];
    for (let i = 0; i < arr.length; i += size) result.push(arr.slice(i, i + size));
    return result;
}

function chunkSizeForWidth(width: number): number {
    if (width > 1394) return 6;
    if (width > 1204) return 5;
    if (width > 974)  return 4;
    if (width > 744)  return 3;
    if (width > 514)  return 2;
    return 1;
}

const FacilityList: React.FC<Props> = ({ onError }) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const syncfusionLocale = (window as any).SYNCFUSION_LOCALE;
    const [facilities, setFacilities] = useState<IHomeFacility[]>(HomeFacilityStore.getAll());
    const [chunks, setChunks] = useState<IHomeFacility[][]>([]);
    const [chunkSize, setChunkSize] = useState(6);
    const [sidebarOpen, setSidebarOpen] = useState(HomeStore.getSidebarOpen());
    const mountedRef = useRef(true);

    const recompute = useCallback((width: number, allFacilities: IHomeFacility[]) => {
        const size = chunkSizeForWidth(width);
        const sorted = [...allFacilities];
        if (sorted.length > 0) ListHelper.sort(sorted, 'Name');
        setChunkSize(size);
        setChunks(chunkArray(sorted, size));
    }, []);

    const onStoreChange = useCallback(() => {
        if (!mountedRef.current) return;
        const all = HomeFacilityStore.getAll();
        setFacilities(all);
        setSidebarOpen(HomeStore.getSidebarOpen());
        if (containerRef.current) recompute(containerRef.current.offsetWidth, all);
    }, [recompute]);

    useEffect(() => {
        mountedRef.current = true;
        HomeFacilityStore.addChangeListener(onStoreChange);
        HomeStore.addChangeListener(onStoreChange);

        HomeFacilityActions.getAllFacilities().catch(err => onError?.(err));

        const observer = new ResizeObserver(() => {
            if (containerRef.current) {
                recompute(containerRef.current.offsetWidth, HomeFacilityStore.getAll());
            }
        });
        if (containerRef.current) observer.observe(containerRef.current);

        return () => {
            mountedRef.current = false;
            HomeFacilityStore.removeChangeListener(onStoreChange);
            HomeStore.removeChangeListener(onStoreChange);
            observer.disconnect();
        };
    }, [onStoreChange, recompute, onError]);

    // Initial chunk computation once data arrives
    useEffect(() => {
        if (containerRef.current && facilities.length > 0) {
            recompute(containerRef.current.offsetWidth, facilities);
        }
    }, [facilities, recompute]);

    const loadFacility = (id: string) => {
        const expandStr = sidebarOpen ? '&expand=true' : '';
        window.location.href = `/Facility?facilityId=${id}${expandStr}`;
    };

    const renderCard = (item: IHomeFacility, key: number) => (
        <div key={key} className="card cursor-pointer f-card" onClick={() => loadFacility(item.ID)}>
            <div className="card-body">
                <div className="card-image">
                    <img src={item.ThumbnailImageUrl ?? facilityImg} alt={item.Name} />
                </div>
                <div className="heading-1 my-3">{item.Name}</div>
                <div className="heading-2">{item.Location}</div>
            </div>
        </div>
    );

    const renderSlide = (chunk: IHomeFacility[], chunkIndex: number) => {
        const blanks = chunkSize - chunk.length;
        return (
            <div className="d-flex j-cse" key={`chunk-${chunkIndex}`}>
                {chunk.map((item, i) => <div key={`item-${i}`}>{renderCard(item, i)}</div>)}
                {blanks > 0 && Array.from({ length: blanks }, (_, i) => (
                    <div key={`blank-${i}`}><div className="blank-card" /></div>
                ))}
            </div>
        );
    };

    return (
        <div className="col-lg-12 control-section home-content" ref={containerRef}>
            <div className="content-wrapper">
                <div className="e-card" id="basic">
                    <div className="e-card-header">
                        <div className="e-card-header-caption">
                            <div className="e-card-title">{InovxLoader.t('home:facilities')}</div>
                        </div>
                    </div>
                    <div className="e-card-content">
                        <div className="control-pane">
                            <div className="default-carousel-section">
                                <div className="control carousel-sample">
                                    {chunks.length > 0 && (
                                        <CarouselComponent
                                            key={chunks.length}
                                            cssClass="default-carousel"
                                            autoPlay={false}
                                            showPlayButton={false}
                                            showIndicators={false}
                                            buttonsVisibility="Visible"
                                            loop={false}
                                            locale={syncfusionLocale || undefined}>
                                            <CarouselItemsDirective>
                                                {chunks.map((chunk, i) => (
                                                    <CarouselItemDirective
                                                        key={i}
                                                        template={() => renderSlide(chunk, i)} />
                                                ))}
                                            </CarouselItemsDirective>
                                        </CarouselComponent>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FacilityList;
